export interface AssetReport {
  id: string;
  yearMonth: string;
  comment: string;
  timestamp: number;
  reportItemList: ReportItem[];
}

export const REPORT_ITEM_TYPE = {
  ASSET: 'ASSET',
  LIABILITY: 'LIABILITY',
} as const;
export type ReportItemType = (typeof REPORT_ITEM_TYPE)[keyof typeof REPORT_ITEM_TYPE];

export const REPORT_OWNER_TYPE = {
  HUSBAND: 'HUSBAND',
  WIFE: 'WIFE',
} as const;
export type ReportOwnerType = (typeof REPORT_OWNER_TYPE)[keyof typeof REPORT_OWNER_TYPE];

export interface ReportItem {
  id: string;
  assetReportId: string;
  owner: ReportOwnerType;
  name: string;
  comment: string;
  type: ReportItemType;
  amount: number;
  excludeYn: boolean;
  prevExistYn: boolean;
}

export const ASSET_TYPE = {
  SAVINGS: 'SAVINGS',
  INVESTMENT: 'INVESTMENT',
  EXPECT_TO_CONSUME: 'EXPECT_TO_CONSUME',
  ETC: 'ETC',
} as const;
export type AssetType = (typeof ASSET_TYPE)[keyof typeof ASSET_TYPE];

export interface AssetItem extends ReportItem {
  assetType: AssetType;
  principalAmount: number;
  returnRate: number;
  /** 해당 기준월에 발생한 배당금/분배금 */
  dividendAmount: number;
}

export const INVESTMENT_TYPE = {
  DOMESTIC_STOCK: 'DOMESTIC_STOCK',
  OVERSEA_STOCK: 'OVERSEA_STOCK',
  GOLD: 'GOLD',
  ETC: 'ETC',
} as const;
export type InvestmentType = (typeof INVESTMENT_TYPE)[keyof typeof INVESTMENT_TYPE];

export interface InvestmentItem extends AssetItem {
  investmentType: InvestmentType;
  principalAmount: number;
  returnRate: number;
}

export const SAVING_TYPE = {
  MONTHLY_SAVINGS: 'MONTHLY_SAVINGS',
  TIME_DEPOSIT: 'TIME_DEPOSIT',
  ETC: 'ETC',
} as const;
export type SavingType = (typeof SAVING_TYPE)[keyof typeof SAVING_TYPE];

export interface SavingItem extends AssetItem {
  savingType: SavingType;
}

export const LIABILITY_TYPE = {
  LOAN: 'LOAN',
  EXPECT_TO_CONSUME: 'EXPECT_TO_CONSUME',
  ETC: 'ETC',
} as const;
export type LiabilityType = (typeof LIABILITY_TYPE)[keyof typeof LIABILITY_TYPE];

export interface LiabilityItem extends ReportItem {
  liabilityType: LiabilityType;
}

export interface ReportItemCompareData {
  title: string;
  prevItem?: ReportItem;
  item?: ReportItem;
  changeAmount: number;
}

export interface InvestmentItemCompareData extends ReportItemCompareData {
  title: string;
  prevItem?: InvestmentItem;
  item?: InvestmentItem;
  changePrincipalAmount: number;
  changeEvaluationProfitAmount: number;
  changeDividendAmount: number;
  changeAmount: number;
}

export interface UpdateAssetReportRequest {
  yearMonth: string;
  reportItemList: ReportItem[];
}

export interface CompareAssetCardData {
  totalChangeAmount: number;
  savingChangeAmount: number;
  investmentChangeAmount: number;
  investmentChangePrincipalAmount: number;
  investmentChangeProfitAmount: number;
  investmentChangeDividendAmount: number;
  etcChangeAmount: number;
  compareSavingItemList: ReportItemCompareData[];
  compareInvestmentItemList: InvestmentItemCompareData[];
  compareEtcItemList: ReportItemCompareData[];
}

export const REPORT_ITEM_TYPE_OPTION_LIST: { label: string; value: ReportItemType }[] = [
  {
    value: REPORT_ITEM_TYPE.ASSET,
    label: '자산',
  },
  {
    value: REPORT_ITEM_TYPE.LIABILITY,
    label: '부채',
  },
];

export const ASSET_TYPE_OPTION_LIST: { label: string; value: AssetType }[] = [
  {
    value: ASSET_TYPE.SAVINGS,
    label: '저축',
  },
  {
    value: ASSET_TYPE.INVESTMENT,
    label: '투자',
  },
  {
    value: ASSET_TYPE.EXPECT_TO_CONSUME,
    label: '지출예정',
  },
  {
    value: ASSET_TYPE.ETC,
    label: '기타',
  },
];

export const LIABILITY_TYPE_OPTION_LIST: { label: string; value: LiabilityType }[] = [
  {
    value: LIABILITY_TYPE.LOAN,
    label: '대출',
  },
  {
    value: LIABILITY_TYPE.EXPECT_TO_CONSUME,
    label: '지출예정',
  },
  {
    value: LIABILITY_TYPE.ETC,
    label: '기타',
  },
];

export const OWNER_TYPE_OPTION_LIST: { label: string; value: ReportOwnerType }[] = [
  {
    value: REPORT_OWNER_TYPE.HUSBAND,
    label: '남편',
  },
  {
    value: REPORT_OWNER_TYPE.WIFE,
    label: '아내',
  },
];
